import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const create_new_ministry = async (body) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry`,
        method: "POST",
        body: JSON.stringify(body)
    })
}

export const get_all_ministries = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry`,
        method: "GET"
    })
}

export const get_ministry_by_id = async (id) => {
    if (!id) return { error: "No ministry id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/id/${id}`,
        method: "GET"
    })
}

export const update_ministry = async (id, body) => {
    if (!id) return { error: "No ministry id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/id/${id}`,
        method: "PUT",
        body: JSON.stringify(body)
    })
}

export const delete_ministry = async (id) => {
    if (!id) return { error: "No ministry id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/ministry/id/${id}`,
        method: "DELETE"
    })
}
